import { action } from 'typesafe-actions';
import { PageActionTypes } from './types';

// Here we use the `action` helper function provided by `typesafe-actions`.
// This library provides really useful helpers for writing Redux actions in a type-safe manner.
// For more info: https://github.com/piotrwitek/typesafe-actions
export const pageRequest = (data: object) =>
  action(PageActionTypes.PAGE_REQUEST, data);

// Remember, you can also pass parameters into an action creator. Make sure to
// type them properly as well.
export const pageSuccess = (data: object) =>
  action(PageActionTypes.PAGE_SUCCESS, data);
export const pageError = (message: Array<object>) =>
  action(PageActionTypes.PAGE_ERROR, message);

export const clearForms = () => action(PageActionTypes.CLEAR_FORMS);

export const updateItemRequest = (data: object) =>
  action(PageActionTypes.UPDATE_ITEM_REQUEST, data);
export const updateItemSuccess = (data: object) =>
  action(PageActionTypes.UPDATE_ITEM_SUCCESS, data);

export const submitFormRequest = (data: object) =>
  action(PageActionTypes.SUBMIT_FORM_REQUEST, data);
export const submitFormSuccess = (data: object) =>
  action(PageActionTypes.SUBMIT_FORM_SUCCESS, data);

export const setSubmitButtonId = (data: object) =>
  action(PageActionTypes.SET_SUBMIT_BUTTON_ID, data);
export const unsetSubmitButtonId = () =>
  action(PageActionTypes.UNSET_SUBMIT_BUTTON_ID);

export const logoutRequest = () => action(PageActionTypes.PAGE_LOGOUT_REQUEST);

export const previewFile = (data?: object) =>
  action(PageActionTypes.PREVIEW_FILE, data);
